export function getDomainName() {
    const dotIndex = window.location.hostname.indexOf('.');
    return window.location.hostname.substring(dotIndex + 1);
}

export function getUrlParameter(parameterName) {
    const queryString = window.location.search.split('?')[1];
    const params = new URLSearchParams(queryString);
    return params.get(parameterName);
}

export function convertCashSiteUatUrl(url) {
    // uat url 格式是：'https://qab01-simplec-1234567.u.nova88.com/'
    const urlObj = new URL(url);
    const { hostname } = urlObj;
    const TARGET_STRING = 'simplec';
    const targetIndex = hostname.indexOf(TARGET_STRING);
    if (targetIndex === -1) {
        throw new Error(`URL does not contain "${TARGET_STRING}"`);
    }

    const result = hostname.substring(targetIndex);

    return result.replace('.u.', '.');
}

export function checkIsSimplecUrl(url = window.location.href) {
    if (!url) return false;
    
    try {
        const { hostname } = new URL(url);
        return hostname.toLowerCase().includes('simplec');
    } catch {
        return false;
    }
}

export function simplifyUatUrl(url = window.location.href) {
    try {
      const urlObj = new URL(url);
      const hostname = urlObj.hostname;
      
      const parts = hostname.split('.');
      
      // 如果域名只有3個部分且符合 xxx.domain.com 格式，直接返回
      if (parts.length === 3 && !hostname.includes('-')) {
        return `${urlObj.protocol}//${hostname}`;
      }
      
      // 處理複雜格式 (例如: qab03-simplec-251163418864.u.nova88.com)
      // 提取主域名 (nova88.com 或 viva88.com)
      const mainDomainParts = parts.slice(-2); // 取最後兩個部分 (例如: ['nova88', 'com'])
      
      const firstPart = parts[0];
      const prefix = firstPart.split('-')[0]; // 取第一個 '-' 前的部分
      
      const simplifiedHostname = `${prefix}.${mainDomainParts.join('.')}`;
      
      return `${urlObj.protocol}//${simplifiedHostname}`;
      
    } catch (error) {
      return url;
    }
  }

export function removeQabPrefix(hostname) {
    return hostname.replace(/^qab\d+-/, '');
}

export function removeUDot(hostname) {
    return hostname.replace(/\.u\./, '.');
}
